import React from "react"
import { useTranslation } from "react-i18next"

import { APIStatus } from "shared/ui/api-status/APIStatus"

interface ProjectsAPIStatusProps {
  isUnavailable: boolean
}

export const ProjectsAPIStatus = React.memo(
  ({ isUnavailable }: ProjectsAPIStatusProps) => {
    const { t } = useTranslation()
    return (
      <APIStatus
        isUnavailable={isUnavailable}
        unavailableMessage={t("Project.ServiceUnavailable")}
      />
    )
  }
)
